import axios from 'axios';
import urlProduccion from './urlProduccion';

const clienteAxios = axios.create({
    // baseURL: 'http://localhost:8000/' //dev
    baseURL: urlProduccion
});

export default clienteAxios;